import { createFileRoute } from "@tanstack/react-router"
import { ZorchaComparisonPage } from "@/routes/comparison/zorcha-vs-zapify-pro"

export const Route = createFileRoute("/$lang/comparison/zorcha-vs-zapify-pro")({
  component: ZorchaComparisonPage,
})
